import { render, staticRenderFns } from "./Enlarge.vue?vue&type=template&id=5b2db4e8&scoped=true"
import script from "./Enlarge.vue?vue&type=script&lang=js"
export * from "./Enlarge.vue?vue&type=script&lang=js"
import style0 from "./Enlarge.vue?vue&type=style&index=0&id=5b2db4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2db4e8",
  null
  
)

export default component.exports